module.exports = __webpack_public_path__ + "img/重庆航空金融总部.d968ec32.png";